import React, { memo } from 'react';
import { Empty } from 'antd';
function Index(props) {
  return <Empty className="w-100  p-5" image={Empty.PRESENTED_IMAGE_SIMPLE} />;
}

export default memo(Index);
